var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:comment-2-fill",
    clipPath: "url(#clip0_1008_1945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7519 9.16667C14.5482 9.16661 15.3308 9.37401 16.0225 9.76845C16.7143 10.1629 17.2913 10.7307 17.6968 11.4161C18.1023 12.1014 18.3223 12.8805 18.335 13.6767C18.3477 14.473 18.1528 15.2587 17.7694 15.9567L18.0911 17.0492C18.1336 17.1935 18.1364 17.3467 18.0993 17.4926C18.0621 17.6384 17.9863 17.7716 17.8799 17.878C17.7735 17.9844 17.6403 18.0602 17.4945 18.0974C17.3486 18.1345 17.1955 18.1317 17.0511 18.0892L15.9594 17.7675C15.3469 18.1039 14.6655 18.2957 13.9675 18.3283C13.2694 18.361 12.5731 18.2336 11.9319 17.9558C11.2906 17.6781 10.7213 17.2574 10.2676 16.726C9.81386 16.1945 9.48765 15.5663 9.31392 14.8894C9.14019 14.2126 9.12354 13.5049 9.26525 12.8206C9.40695 12.1363 9.70325 11.4935 10.1315 10.9413C10.5597 10.389 11.1086 9.94205 11.7361 9.63447C12.3636 9.3269 13.0531 9.16689 13.7519 9.16667ZM9.16857 2.5C10.8268 2.50023 12.4383 3.04978 13.7512 4.06279C15.0641 5.0758 16.0044 6.49519 16.4252 8.09917C15.164 7.50134 13.7389 7.34291 12.3772 7.64911C11.0154 7.95532 9.79532 8.70854 8.91138 9.78873C8.02745 10.8689 7.53052 12.2139 7.4998 13.6093C7.46909 15.0047 7.90635 16.3703 8.74191 17.4883C7.53598 17.4212 6.36437 17.0623 5.32774 16.4425L3.11941 17.0925C2.97456 17.1352 2.82087 17.1381 2.67452 17.1009C2.52817 17.0636 2.39457 16.9876 2.28779 16.8808C2.181 16.774 2.10498 16.6404 2.06772 16.4941C2.03046 16.3477 2.03335 16.194 2.07607 16.0492L2.72607 13.8408C2.04727 12.7023 1.68232 11.4043 1.66838 10.0788C1.65445 8.7534 1.99204 7.44795 2.64676 6.29543C3.30148 5.14291 4.24995 4.18449 5.39558 3.51779C6.54121 2.85108 7.84307 2.49989 9.16857 2.5Z",
    fill: "url(#paint0_linear_1008_1945)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1008_1945",
    x1: 10.0018,
    y1: 2.5,
    x2: 10.0018,
    y2: 18.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1008_1945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.3f230b8b3ef80a5357ab32d910ecad14.svg";
export { ForwardRef as ReactComponent };